import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },

  generateVoMFiservreports({ state }, payload) {
    let url = `${appConfig.apiEndPoint}${
      endpoint.VoMFiservReport.vomFiservOrderReport
    }`
    return axios
      .post(url, payload, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  async fetchVoMFiservreports({ state }, orderID) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.VoMFiservReport.GetVomFiservOrderDetails
        }?orderId=${orderID}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },
  async vomGenerateReport({ state }, orderID) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.VoMFiservReport.generateReport
        }?orderId=${orderID}`,
        {},
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  async vomAccountsEnrolled({ state }, orderID) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.VoMFiservReport.accountsEnrolled
        }?orderId=${orderID}`,
        {},
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  async getAccountsInfo({ state }, orderID) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.VoMFiservReport.getAccountsInfo
        }?orderId=${orderID}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  async generatepdfReport({ state }, orderID) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.VoMFiservReport.getAccountDetails
        }?orderId=${orderID}`,
        {},
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  async fetchSignonInfo({ state }, orderID) {
    // let orderID = payload.orderId
    // delete payload.orderId
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.VoMFiservReport.vomFiservSignon
        }?orderId=${orderID}`,
        {},
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  async resendInvitationEmail({ state }, orderID) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.VoAFiservReport.resendEmail
        }?orderId=${orderID}`,
        {},
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  vomFiservResendOtp({ state }, { guid }) {
    let url = `${appConfig.apiEndPoint}${
      endpoint.VoMFiservReport.vomFiservResendOtp
    }/${guid}`
    return axios
      .post(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  vomFiservOtpExpire({ state }, guid) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.VoAFiservReport.voaFiservOtpExpire
        }/${guid}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  verifyVomFiservOTP({ state }, { orderId, otpnumber }) {
    let url = `${appConfig.apiEndPoint}${
      endpoint.VoMFiservReport.vomFiservOtpScreen
    }/${orderId}/${otpnumber}`
    return axios
      .post(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  vomFiservDeleteUser({ state }, orderId) {
    let url = `${appConfig.apiEndPoint}${
      endpoint.VoAFiservReport.voaFiservDeleteUser
    }/${orderId}`
    return axios
      .post(
        url,
        {},
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  getVomFiservSummary({ state }, orderId) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.VoMFiservReport.vomFiservSummary
        }?orderId=${orderId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },
  vomFiservResendEmail({ state }, orderId) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.VoMFiservReport.vomFiservResendEmail
        }?orderId=${orderId}`,
        {},
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  vomFiservCancelOrder({ state }, orderId) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.VoMFiservReport.vomFiservCancelOrder
        }?orderId=${orderId}`,
        {},
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  vomFiservRetry({ state }, orderId) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.VoMFiservReport.vomFiservRetry
        }?orderId=${orderId}`,
        {},
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  vomNoOtpGuid({ state }, { guid }) {
    let url = `${appConfig.apiEndPoint}${
      endpoint.VoMFiservReport.vomonlyGuid
    }/${guid}`
    return axios
      .post(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
}
function setHeaders() {
  const path = window.location.href
  const vomWidgetsUrl = path
    .toLowerCase()
    .includes('mvx-mortgageverification-widgets')
  const vomGuidUrl = path
    .toLowerCase()
    .includes('mvxmortgageverification-widgets')
  const vomThanksUrl = path.includes('vom-fiserv-thanks')
  if (vomWidgetsUrl || vomThanksUrl || vomGuidUrl) {
    return {
      'Content-Type': 'application/json',
      Authorization: '',
    }
  } else {
    return {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
    }
  }
}
function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
